<template>
    <div class="liquid-gauge" :class="cardSize">
        <svg viewBox="0 0 160 160" preserveAspectRatio="xMidYMid meet">
            <defs>
                <clipPath :id="clipId">
                    <circle :cx="CENTER" :cy="CENTER" :r="RADIUS" />
                </clipPath>
            </defs>

            <!-- 液面：矩形加上一顆扁橢圓做出略帶弧度的水面 -->
            <g :clip-path="`url(#${clipId})`" v-if="ratio > 0">
                <rect x="0" :y="fillTop" width="160" :height="160 - fillTop" :fill="color" />
                <ellipse cx="80" :cy="fillTop" rx="80" ry="5" :fill="color" />
            </g>

            <circle :cx="CENTER" :cy="CENTER" :r="RADIUS" class="outline" :style="{ stroke: color }" />

            <text :x="CENTER" :y="CENTER + 11" class="value-text">
                {{ displayValue }}<tspan class="value-unit">{{ unit ? ` ${unit}` : '' }}</tspan>
            </text>
        </svg>
    </div>
</template>

<script>
// 液面填充圓。適用於「水位」型的有界指標（電池 SOC），
// 液面高度直接對應數值，不需對照座標軸即可讀出。
import { levelColor } from './gaugeBands'

const CENTER = 80
const RADIUS = 62
const TOP = CENTER - RADIUS
const BOTTOM = CENTER + RADIUS

// clipPath 的 id 在整份文件中必須唯一，同頁出現多個實例時才不會互相蓋掉
let instanceCount = 0

export default {
    name: 'LiquidGaugeChart',
    props: {
        value: { type: [Number, String], default: null },
        min: { type: Number, default: 0 },
        max: { type: Number, default: 100 },
        unit: { type: String, default: '' },
        cardSize: { type: String, default: 'small' },
    },
    data() {
        instanceCount += 1
        return { CENTER, RADIUS, clipId: `liquid-clip-${instanceCount}` }
    },
    computed: {
        numericValue() {
            const n = Number(this.value)
            return this.value === null || this.value === '' || Number.isNaN(n) ? null : n
        },
        ratio() {
            if (this.numericValue === null) return 0
            const span = this.max - this.min || 1
            return Math.min(1, Math.max(0, (this.numericValue - this.min) / span))
        },
        fillTop() {
            return BOTTOM - this.ratio * (BOTTOM - TOP)
        },
        color() {
            return levelColor(this.numericValue)
        },
        displayValue() {
            return this.numericValue === null ? '—' : this.numericValue
        },
    },
}
</script>

<style lang="scss" scoped>
.liquid-gauge {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        width: 100%;
        height: 100%;
    }
}

.outline {
    fill: none;
    stroke-width: 2.5;
    opacity: 0.75;
    transition: stroke 0.3s;
}

.value-text {
    text-anchor: middle;
    font-size: 34px;
    font-weight: bold;
    fill: #2d3748;
    /* 水位線可能剛好切過文字，加白色描邊確保在液面上下都讀得清楚 */
    stroke: #fff;
    stroke-width: 4px;
    paint-order: stroke fill;
}

.value-unit {
    font-size: 17px;
    font-weight: normal;
}
</style>
